import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact">
      <div className="box-left-contact">
        <h2>Contáctanos</h2>
        <p>
          ¿Tienes alguna pregunta o necesitas más información? No dudes en
          contactarnos. Estamos aquí para ayudarte con cualquier consulta que
          puedas tener sobre nuestros servicios de reparación de celulares.
          Puedes enviarnos un mensaje a través de WhatsApp o llamarnos
          directamente. ¡Esperamos poder asistirte pronto!
        </p>
        <p>
          <strong>WhatsApp:</strong> +54 9 341 6697243
        </p>
        <p>
          <strong>Email:</strong> alansuarez641@hotmail.com
        </p>
        <div className="time">
          <h2>Horario</h2>
          <p>
            <strong>Lunes a Sabado:</strong> 10:00 - 20:00
            <br />
            <strong>Domingo</strong> Solo WhatsApp
          </p>
        </div>
      </div>
      <div className="box-right-contact">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d836.8521841992751!2d-60.672485953904726!3d-32.96661652484025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab0000368e23%3A0x46e5328811d84825!2sTecniPlus%2B!5e0!3m2!1ses!2sar!4v1775770141572!5m2!1ses!2sar"
          title="TecniPlus+"
          width="400"
          height="300"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
